import styled from 'styled-components';

export const Row = styled.div<{
  shouldCollapse?: boolean;
}>`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 991px) {
    flex-direction: ${(props): string =>
      props.shouldCollapse ? 'column' : 'row'};
  }
`;
